<template>
  <div>

  </div>
</template>

<script>
export default {
  props: {
    open: {},
    earth: {},
    cluster: {},
    markers: {}
  },
  mounted () {
    this.makeMarker()
  },
  data () {
    return {
      marker: false
    }
  },
  watch: {
    open () {
      if (this.marker) {
        if (this.open) {
          this.marker.pop.openPopup()
        } else {
          this.marker.pop.closePopup()
        }
      }
    }
  },
  methods: {
    makeMarker () {
      var WE = window.WE
      let markers = this.markers
      let earth = this.earth
      let pos = this.cluster[0].pos

      var marker = WE.marker([pos.lat, pos.lng]).addTo(earth)
      this.marker = marker
      this.$emit('marker', this.marker)
      marker.on('click', () => {
        if (window.lastMarkerClicked === marker) {
          return
        } else {
          window.lastMarkerClicked = marker
        }
        markers.forEach(m => m.pop.closePopup())
        pop.openPopup()
        // setTimeout(() => {
        //   markers.forEach(m => m.pop.closePopup())
        //   pop.openPopup()
        // }, 2000)
        this.$emit('click', {
          pos,
          earth
        })
      })

      /*
      <span style="text-decoration: underline; font-weight: bold;" onclick="javascript:window.goRoom({ title: 'room 123456' })">
          Welcome
        </span>
        // Estimation of GeoIP: Lat: ${pos.lat} Lng: ${pos.lng}
      */

      let make1Box = (pin) => {
        return `
          <div style="width: 100%; display: flex; text-align: left; margin-bottom: 7px;">
            <div style="margin-right: 9px;">
              <img style="width: 40px; height: 40px; border-radius: 50%; cursor: pointer;" onclick='window.onClickAvatarForPin(${JSON.stringify(escape(JSON.stringify({ ...pin })))})' src="${pin.person.avatar}" />
            </div>
            <div style="
              display: flex;
              flex-direction: column;
              justify-content: space-around;
            ">
              <div style="font-weight: bold;">
                @${pin.person.name}
              </div>
              ${pin.pos.locale === 'unknown' ? '' : '<div>'}
                ${pin.pos.locale === 'unknown' ? '' : pin.pos.locale}
              ${pin.pos.locale === 'unknown' ? '' : '</div>'}
            </div>
          </div>
        `
      }

      let makeList = () => {
        let inner = this.cluster.reduce((c, i) => {
          c += make1Box(i)

          return c
        }, '')
        return `
          <div style="max-height: 250px; overflow: auto; -webkit-overflow-scrolling: touch;">
            ${inner}
          </div>
        `
      }

      let pop = marker.bindPopup(makeList(), 250, false)
      // window.addEventListener('closepop', () => {
      //   pop.openPopup()
      // }, false)
      marker.pop = pop
      markers.push(marker)
      if (this.open) {
        pop.openPopup()
      }
    }
  },
  beforeDestroy () {
    this.marker.removeFrom(this.earth)
  }
}
</script>

<style>
.we-pp-content{
  width: calc(100% - 30px);
}

.locale .we-pp-content{
  width: calc(100% - 15px * 2.0);
  margin: 15px;
}
</style>
